
import { AmmunitionStockEntityDecoratorBase } from './ammunition-stock.decorator.base';


export class AmmunitionStockEntityDecorator extends AmmunitionStockEntityDecoratorBase {
  constructor() {
    super();
  }
}



